import { createSlice } from "@reduxjs/toolkit";

const initialModalState = {
  showModal: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState: initialModalState,
  reducers: {
    setModal(state, action) {
      state.showModal = action.payload;
    },
  },
});

export const modalActions = modalSlice.actions;
export default modalSlice.reducer;
